import React from 'react';
import { FIELD_COPY } from '../data/application-copy';

const INPUT_TYPES = { EMAIL: 'email', PHONE: 'tel', SALARY: 'number' };
const AUTOCOMPLETE = { NAME: 'name', EMAIL: 'email', PHONE: 'tel' };
const HINTS = { PHONE: FIELD_COPY.phoneHint, SALARY: FIELD_COPY.salaryHint };

// One candidate field. subtype picks the input; anything unrecognised is plain
// text. inputId must be unique on the page — several positions' forms can be
// mounted at once.
const CandidateFieldInput = ({
  field,
  inputId,
  value,
  error,
  disabled,
  inputRef,
  onChange,
}) => {
  const hint = HINTS[field.subtype];
  const hintId = `${inputId}-hint`;
  const errorId = `${inputId}-error`;
  const describedBy =
    [hint && hintId, error && errorId].filter(Boolean).join(' ') || undefined;
  const isSalary = field.subtype === 'SALARY';
  const currency = isSalary && field.options && field.options.currency;

  return (
    <div className="__application-field">
      <div className={currency ? '__application-field-row' : undefined}>
        <div className="__application-field-main">
          <label htmlFor={inputId}>
            {field.name}
            {field.required && (
              <span className="__application-required" aria-hidden="true">
                *
              </span>
            )}
          </label>
          <input
            id={inputId}
            ref={inputRef}
            type={INPUT_TYPES[field.subtype] || 'text'}
            inputMode={isSalary ? 'decimal' : undefined}
            autoComplete={AUTOCOMPLETE[field.subtype]}
            placeholder={isSalary ? FIELD_COPY.salaryPlaceholder : undefined}
            value={value}
            required={field.required}
            disabled={disabled}
            aria-invalid={error ? true : undefined}
            aria-describedby={describedBy}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
        {currency && (
          <div className="__application-field-currency">
            <label htmlFor={`${inputId}-currency`}>
              {FIELD_COPY.currencyLabel}
            </label>
            <input
              id={`${inputId}-currency`}
              value={currency}
              readOnly
              disabled={disabled}
            />
          </div>
        )}
      </div>
      {hint && (
        <p id={hintId} className="__application-hint">
          {hint}
        </p>
      )}
      {error && (
        <p id={errorId} className="__application-error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default CandidateFieldInput;
